import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=ca0a3fea&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca0a3fea')) {
      api.createRecord('ca0a3fea', component.options)
    } else {
      api.reload('ca0a3fea', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=ca0a3fea&", function () {
      api.rerender('ca0a3fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nnrJQgp8g5lq/JS/comp/FavElement.vue"
export default component.exports